var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-dropdown{fill:#141b29}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "dropdown_24dp",
    transform: "translate(-3629.5 7996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "frame",
    transform: "translate(3629.5 -7996)",
    style: {
      fill: "transparent"
    },
    d: "M0 0h24v24H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    className: "cls-dropdown",
    d: "M4.232.922a1 1 0 0 1 1.536 0L8.633 4.36A1 1 0 0 1 7.865 6h-5.73a1 1 0 0 1-.768-1.64z",
    transform: "rotate(180 1823.269 -3988.383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    className: "cls-dropdown",
    d: "M4.232.922a1 1 0 0 1 1.536 0L8.633 4.36A1 1 0 0 1 7.865 6h-5.73a1 1 0 0 1-.768-1.64z",
    transform: "translate(3636.5 -7991.25)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.2ed06fc7.svg";
export { ForwardRef as ReactComponent };